import { render, staticRenderFns } from "./MasterAdminPermissionGuardContainer.vue?vue&type=template&id=0cdbf1ba&"
import script from "./MasterAdminPermissionGuardContainer.vue?vue&type=script&lang=js&"
export * from "./MasterAdminPermissionGuardContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports